setPristineObjects();

function preLoadNecessaryData () {
    return $.ajax({
        url: "./general/settings",
        method: "GET",
        dateType: "JSON",
        data: {preLoad: true, detailed: true}
    })
}

function wire (data) {
    angular.module("app").value("preLoadedData", {data: data});
    document.getUserData = function () {
        return angular.copy(data.userInfo);
    };
    angular.element(document.body).ready(function () {
        angular.bootstrap($(document.body), ["app"]);
    });
}

function setPristineObjects() {
    angular.module("app").value("preLoadedData", {data: null});
}


function forceWire () {
    angular.element(document.body).ready(function () {
        angular.bootstrap($(document.body), ["app"]);
    });
}

//app wire point
preLoadNecessaryData().success(wire).error(forceWire);